import moment from 'moment';

import templateUrl from './work-order-manual-claim-list-container.component.html';
import { containsInvariant } from '../../../../../core/services/filter-util';
import { EmployeeService } from '../../../../../core/services';
import { UtilityService } from '../../../../../core/services/utility.service';

export const WorkOrderManualClaimListContainerComponent = {
    controller: WorkOrderManualClaimContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        workOrderManualClaims: "<"
    }
};

function WorkOrderManualClaimContainerController($uibModal,
    employeeService: EmployeeService, utilityService: UtilityService,
    workOrderManualClaimService) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;


    vm.filterWorkOrderManualClaims = filterWorkOrderManualClaims;
    vm.filters = {};
    vm.$onInit = onInit;
    vm.onViewDetails = onViewDetails;
    vm.onApproveClaim = onApproveClaim;
    vm.refreshClaims = refreshClaims;
    vm.canUpdate;
    vm.loaded = false;
    vm.showFilters = true;

    function onInit() {
        const loaded = employeeService.retrievePermissions({
            stateName: "leads.listWorkOrderManualClaim"
        }).then(access => vm.canUpdate = access.CanUpdate);
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loaded, "Initial load failed")
        ).then(() => vm.loaded = true);
        vm.filters.modifiedSince = moment().startOf('day').toDate();
    }

    function onViewDetails(calim) {
        $uibModal.open({
            component: "apexWorkOrderManualClaimPreviewModal",
            resolve: {
                workOrderClaim: calim,

            },
            windowClass: 'xx-dialog pagespinner',
            size: 'sm',
            backdrop: 'static'
        })
    }

    function refreshClaims() {
        utilityService.showLoading();
        const query = {
            modifiedSince: kendo.format("{0:yyyy-MM-dd}", vm.filters.modifiedSince)
        };
        workOrderManualClaimService.retrieveWorkOrderMaualClaims(query)
            .then(function (claims) {
                vm.workOrderManualClaims = claims.filter(filterWorkOrderManualClaims);
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Refresh failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading);
    }

    function filterWorkOrderManualClaims(claim) {
        return (!vm.filters.office || !claim.WorkOrder.IcdOfficeID
            || containsInvariant(claim.WorkOrder.IcdOfficeName, vm.filters.office))
            && (!vm.filters.client || containsInvariant(
                claim.WorkOrder.IcdCorporationName, vm.filters.client))
            && (!vm.filters.employee || containsInvariant(
                claim.WorkOrder.EmployeeName, vm.filters.employee))
            && (!vm.filters.pendingClaimsOnly || !claim.Approved);
    }


    function onApproveClaim(claim) {
        if (confirm("Are you sure you want to continue ?")) {
            utilityService.showLoading();
            const patchRequest = {
                Approved: true
            };
            workOrderManualClaimService.patchWorkOrderManualClaim(claim.WorkOrderManualClaimID, patchRequest)
                .catch(function (ex) {
                    console.error(ex);
                    alert("Refresh failed: " + utilityService.getExceptionMessage(ex));
                })
                .then(function () {
                    refreshClaims();
                })
                .then(utilityService.hideLoading)
        }
    }
}
